import { message } from "antd";
import { I18n } from "react-redux-i18n";

import { handleGenericApiError } from "app/api/error";
import JobLogRequests from "app/api/jobLog";

import { addLoading, removeLoading } from "./loading";

export const ACTION_SAVE_JOBLOGS = "jobLog:ACTION_SAVE_JOBLOGS";
export const ACTION_SAVE_JOB_MONITORING = "jobLog:ACTION_SAVE_JOB_MONITORING";

export const fetchJobLogs = params => async dispatch => {
  dispatch(addLoading());
  try {
    let data = await JobLogRequests.fetchJobLogs(params);
    dispatch({ type: ACTION_SAVE_JOBLOGS, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const downloadJobLog = params => async () => {
  if (
    params.searchParameter?.InitialJobDate &&
    params.searchParameter?.EndJobDate
  ) {
    var initialDate = params.searchParameter?.InitialJobDate.split(" ");
    var endDate = params.searchParameter?.EndJobDate.split(" ");
    initialDate = new Date(initialDate[0]);
    endDate = new Date(endDate[0]);
    var totalDaysDiff = Math.abs(endDate - initialDate) / (1000 * 60 * 60 * 24);
    if (totalDaysDiff < 2) {
      try {
        const response = await JobLogRequests.downloadJobLog(
          params.searchParameter
        );
        const link = document.createElement("a");
        link.href = response.data;
        link.setAttribute("download", "joblogs.csv");
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        handleGenericApiError(err);
      }
    } else {
      message.info(I18n.t("errors.DATE_FILTER_PERIOD_INVALID_LOGS"));
      return false;
    }
  } else {
    message.info(I18n.t("errors.DATE_FILTER_ERROR"));
    return false;
  }
};

export const fetchJobMonitoring = params => async dispatch => {
  dispatch(addLoading());
  try {
    let data = await JobLogRequests.fetchJobMonitoring(params);
    dispatch({ type: ACTION_SAVE_JOB_MONITORING, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};
